export default __webpack_public_path__ + "static/media/key.aa1d77aa.png";